import { message } from "antd";
import endpoints from "../utils/endpoints";
import { Api } from "./api";
import { notificationError } from "./notification";
import { createQueryParams } from "../utils/stringUtils";


export async function getSmartSearchOptions(params: any, type?: string){

  let url = endpoints.smartSearch

  switch (type) {
    case 'listgames':
      url = endpoints.smartSearchGames
      break;
    case 'bingodefinition':
      url = endpoints.smartSearchBingoGames
      break;
    default: 
      url = endpoints.smartSearch
  }

  let res = [{
      id: null,
      name:   ''
  }]

  await Api.get(url, {params}).then((response) => {
    const {data} = response
    if(!data) return 
    if(data.error || data.return === false) return notificationError('Something went wrong with smart search')
    res = response.data
  }).catch((err: string) => {
    console.error(err)
  })

  return res
}